// Product Review Write Button Handler
// Dispatches custom event to React component

class ProductReviewWriteButton {
  init() {
    // Handle all write review buttons - use more specific selector
    const writeReviewButtons = document.querySelectorAll(
      'button[data-product-id][id="write-review-button"], button[data-product-id][class*="review-summary-write-button"]'
    );

    writeReviewButtons.forEach((button) => {
      button.addEventListener("click", (e) => {
        e.preventDefault();
        const productId = parseInt(button.getAttribute("data-product-id"), 10);

        if (productId > 0) {
          // Dispatch custom event to React component
          const event = new CustomEvent("product-review-write", {
            detail: { productId },
          });
          window.dispatchEvent(event);
        }
      });
    });
  }
}

export default ProductReviewWriteButton;
